// extracted by mini-css-extract-plugin
export default {"sticky":"Assets_sticky__6bmC+","stickyTop":"Assets_stickyTop__-JIN4"};